import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isVertical", "isInline", "className", "divRef", "align", "appearance", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "paddingX", "paddingY", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "marginX", "marginY"];
import * as React from 'react';
import cn from 'classnames';
import { Enum, SizeType, useSpacingProps } from '../../../library';
import { MenuHeader } from './menu-header';
import { MenuDivider } from './menu-divider';
import { MenuItem, MenuLink } from './menu-item';
import { MenuDropdown } from './menu-dropdown';
export var menuClasses = {
  MAIN: 'menu',
  ITEM: 'menu__item',
  DIVIDER: 'menu__divider',
  TEXT: 'menu__item-text',
  LABEL: 'menu__item-label',
  HEADER: 'menu__header',
  HEADER_TEXT: 'menu__header-text',
  HAS_DROPDOWN: '-dropdown'
};
export var MenuAlignmentType = Enum({
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center',
  JUSTIFY: 'justify',
  FILL: 'fill'
});
export var MenuAppearanceType = Enum({
  TEXT: 'text',
  PILL: 'pill',
  UNDERLINE: 'underline'
});
export var Menu = function Menu(props) {
  var isVertical = props.isVertical,
    isInline = props.isInline,
    className = props.className,
    divRef = props.divRef,
    align = props.align,
    variant = props.appearance,
    padding = props.padding,
    paddingBottom = props.paddingBottom,
    paddingLeft = props.paddingLeft,
    paddingRight = props.paddingRight,
    paddingTop = props.paddingTop,
    paddingX = props.paddingX,
    paddingY = props.paddingY,
    margin = props.margin,
    marginBottom = props.marginBottom,
    marginLeft = props.marginLeft,
    marginRight = props.marginRight,
    marginTop = props.marginTop,
    marginX = props.marginX,
    marginY = props.marginY,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var _useSpacingProps = useSpacingProps({
      padding: padding,
      paddingBottom: paddingBottom,
      paddingLeft: paddingLeft,
      paddingRight: paddingRight,
      paddingTop: paddingTop,
      paddingX: paddingX,
      paddingY: paddingY,
      margin: margin,
      marginBottom: marginBottom,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginTop: marginTop,
      marginX: marginX,
      marginY: marginY
    }),
    paddingClasses = _useSpacingProps.paddingClasses,
    marginClasses = _useSpacingProps.marginClasses;
  var classNames = cn(menuClasses.MAIN, _defineProperty({
    '-vertical': isVertical,
    '-inline': isInline,
    '-text': props.appearance === MenuAppearanceType.TEXT,
    '-pill': props.appearance === MenuAppearanceType.PILL,
    '-underline': props.appearance === MenuAppearanceType.UNDERLINE,
    '-sm': props.size === SizeType.SMALL,
    '-lg': props.size === SizeType.LARGE
  }, "-".concat(align), align), paddingClasses, marginClasses, className);
  return React.createElement("div", _extends({
    ref: divRef,
    className: classNames,
    children: props.children
  }, htmlProps));
};
Menu.displayName = 'Menu';
Menu.defaultProps = {
  isVertical: false,
  isInline: false,
  appearance: MenuAppearanceType.TEXT
};
Menu.Divider = MenuDivider;
Menu.Dropdown = MenuDropdown;
Menu.Header = MenuHeader;
Menu.Item = MenuItem;
Menu.Link = MenuLink;